var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('open-navigation'),_c('v-main',{staticClass:"bgcolor",attrs:{"transition":"slide-x-transition"}},[_c('v-container',{attrs:{"fluid":""}},[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }